if (!customElements.get('chronoera-mobile-purchase')) {
  customElements.define('chronoera-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.form = document.getElementById(this.dataset.formId);
      this.section = this.closest('.shopify-section');
      this.button = this.querySelector('button');
      this.label = this.querySelector('[data-mobile-button-text]');
      this.price = this.querySelector('[data-mobile-price]');
      this.status = this.querySelector('[data-mobile-status]');
      if (!this.form || !this.section) return;

      this.sync = () => {
        const source = this.form.querySelector('[ref="addToCartButton"]');
        if (!source) { this.button.disabled = true; return; }
        this.button.disabled = this.busy || source.disabled;
        const label = source.querySelector('.add-to-cart-text__content')?.textContent.trim();
        if (!this.busy && label) this.label.textContent = label;
        const price = this.section.querySelector('product-price .price');
        if (price) {
          const amount = price.textContent.trim();
          const currency = this.dataset.currency;
          this.price.textContent = currency && amount.endsWith(' ' + currency)
            ? amount.slice(0, -currency.length).trim() : amount;
        }
      };
      this.sync();

      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        const source = this.form.querySelector('[ref="addToCartButton"]');
        if (this.busy || !source || source.disabled) {
          this.sync();
          return;
        }
        source.click();
      }, { signal });
      this.form.addEventListener('submit', () => {
        this.busy = true;
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        this.label.textContent = this.dataset.adding;
        this.status.textContent = '';
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => this.complete(), 12000);
      }, { signal });

      this.complete = () => {
        clearTimeout(this.timeout);
        this.busy = false;
        this.button.removeAttribute('aria-busy');
        this.sync();
      };
      this.closest('product-form-component')?.addEventListener('cart:update', (event) => {
        this.complete();
        if (!event.detail?.data?.didError) {
          this.status.textContent = this.dataset.added;
          clearTimeout(this.statusTimeout);
          this.statusTimeout = setTimeout(() => { this.status.textContent = ''; }, 4000);
        }
      }, { signal });
      this.closest('product-form-component')?.addEventListener('cart:error', (event) => {
        this.complete();
        this.status.textContent = event.detail?.data?.message || this.dataset.error;
        this.removeAttribute('data-inline-visible');
      }, { signal });
      this.section.addEventListener('variant:selected', () => { this.button.disabled = true; }, { signal });
      this.section.addEventListener('variant:update', () => { requestAnimationFrame(this.sync); }, { signal });

      this.mutations = new MutationObserver(this.sync);
      this.mutations.observe(this.form, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
      const price = this.section.querySelector('product-price');
      if (price) this.mutations.observe(price, { subtree: true, childList: true, characterData: true });
      const inline = this.form.querySelector('[ref="addToCartButton"]');
      if (inline && 'IntersectionObserver' in window) {
        this.visibility = new IntersectionObserver(([entry]) => {
          this.toggleAttribute('data-inline-visible', entry.isIntersecting && entry.intersectionRatio >= 1);
        }, { threshold: [0, 1], rootMargin: '-100px 0px -100px 0px' });
        this.visibility.observe(inline);
      }
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.mutations?.disconnect();
      this.visibility?.disconnect();
      clearTimeout(this.timeout);
      clearTimeout(this.statusTimeout);
    }
  });
}
